import { SelectedItem, StepMode, stepsStateSchema } from '@order/orderTypes'
import { SelectionStateKey } from '@order/utils/getNextStepHref'
import { useLocalSearchParams } from 'expo-router'
import { useMemo } from 'react'

export const getSelectionState = (
  steps: SelectedItem[],
  item?: SelectedItem
) => {
  if (!item) {
    return JSON.stringify(steps)
  }
  const newState = [...steps, item]
  return JSON.stringify(newState)
}

const parseState = (state?: string) => {
  if (!state) {
    return []
  }
  try {
    const parsed = JSON.parse(state)
    const validated = stepsStateSchema.parse(parsed)
    return validated
  } catch (e) {
    console.error('State parse error', e)
    return []
  }
}

export const parseStateParams = (
  params: Partial<Record<SelectionStateKey, string>>
) => {
  return Object.fromEntries(
    Object.entries(params)
      .filter(([key]) => key.startsWith('state-'))
      .map(([key, value]) => [key.replace('state-', ''), parseState(value)])
  )
}

const useStepsState = () => {
  const params = useLocalSearchParams<{
    ['state-frame']?: string
    orderItemId: string
    stepId: string
    ['state-bundle']?: string
    mode?: StepMode
  }>()

  const { orderItemId, stepId, mode } = params

  const parsed = useMemo(() => {
    return parseStateParams(params)
  }, [params])

  return {
    states: parsed,
    mode,
    orderItemId,
    stepId,
  }
}

export default useStepsState
